interface Props {
  mt: string;
}

const NoResultsMessage: (props: Props) => JSX.Element = (props: Props) => {
  return (
    <div className={`col-lg-12 ${props.mt}`}>
      <div className="d-flex align-items-center justify-content-center">
        <div className="card w-100">
          <div className="py-8 text-center mx-auto mw-20">
            <img src={require("src/assets/images/no-results.svg").default} alt="" />
            
            <p className="mt-8 color-monoNormal">
              No results found
              <br></br>
              Please try another search
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoResultsMessage;
